// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const garchomp_mega: PokeData = {
  "id": 10058,
  "name": "garchomp-mega",
  "height": 19,
  "weight": 950,
  "base_experience": 315,
  "types": [
    PokeType.DRAGON,
    PokeType.GROUND
  ],
  "api_moves": [
    "sand-attack",
    "tackle",
    "take-down",
    "dragon-rage",
    "dig",
    "slash",
    "sandstorm",
    "crunch",
    "sand-tomb",
    "dragon-claw",
    "dragon-rush",
    "fire-fang",
    "dual-chop"
  ],
  "moves": [
    "tackle",
    "sandstorm",
    "crunch",
    "dragon-claw",
    "dragon-rush",
    "fire-fang",
    "mud-slap",
    "bonemerang",
    "dragon-pulse",
    "draco-meteor",
    "scale-shot",
    "mud-shot",
    "bone-throw"
  ],
  "evolution_chain": {
    "id": 230,
    "item": null,
    "species": [
      {
        "name": "gible",
        "order": 464,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gabite",
        "order": 465,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 443,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "garchomp",
        "order": 466,
        "types": [
          PokeType.DRAGON,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 444,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 48,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 116,
    "speed": 100,
    "ability_power": 185
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": true,
  "is_gmax": false,
  "regional_variant": null
} as const;
